import { Play, X } from 'lucide-react';
import { formatFileSize } from '@/lib/upload';
import type { AttachmentItem } from '@/types/attachment';

interface VideoPreviewProps {
  attachment: AttachmentItem;
  onRemove: (id: string) => void;
}

export function VideoPreview({ attachment, onRemove }: VideoPreviewProps) {
  return (
    <div className="group relative w-full max-w-[9rem] overflow-hidden rounded-2xl border border-border/50 bg-muted/30 shadow-sm sm:w-24">
      {attachment.previewUrl ? (
        <div className="relative aspect-square w-full bg-muted/50">
          <img src={attachment.previewUrl} alt={attachment.file.name} className="h-full w-full object-cover" />
          <div className="absolute inset-0 flex items-center justify-center bg-black/30">
            <Play className="h-6 w-6 text-white" />
          </div>
        </div>
      ) : (
        <div className="flex aspect-square w-full items-center justify-center bg-muted/50 text-sm text-muted-foreground">
          Vidéo
        </div>
      )}
      <button
        type="button"
        onClick={() => onRemove(attachment.id)}
        className="absolute right-1 top-1 rounded-full bg-background/80 p-2 text-foreground shadow-sm transition-opacity hover:bg-background touch-manipulation"
        aria-label={`Retirer ${attachment.file.name}`}
      >
        <X className="h-3.5 w-3.5" />
      </button>
      <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent px-2 py-2 text-[11px] text-white">
        <p className="truncate">{attachment.file.name}</p>
        <p>{formatFileSize(attachment.file.size)}</p>
        {typeof attachment.duration === 'number' && <p>{Math.round(attachment.duration)}s</p>}
      </div>
    </div>
  );
}
